<div class="container-modal-lateral">
  <div>
    <span class="title-modal-lateral">{{ visualizar ? 'Detalhes Usuário' : isCadastro ? 'Cadastrar Usuário' : 'Alterar Usuário' }}</span>

    @if (!visualizar) {
      <form [formGroup]="formUsuario" (ngSubmit)="salvarForm()">
        <div class="main-modal-lateral-edicao">
          @if(!isCadastro){
            <div class="flex-row justify-between">
              <app-slide-toggle-padrao [valor]="usuario.ativo" (changeValue)="usuario.ativo = $event; alteracaoService.camposAlterado()"></app-slide-toggle-padrao>
              @if (editarOperador) {
                <app-slide-toggle-padrao labelTrue="Operador" labelFalse="" [valor]="usuario.isOperador" (changeValue)="usuario.isOperador = $event; alteracaoService.camposAlterado()"></app-slide-toggle-padrao>
              }
            </div>
          }

          <div class="align-input-email-button">
            <app-form-field formControlName="email" label="Email" heightFormField="35px" (changeValue)="alteracaoService.camposAlterado()" [isEdicao]="!isCadastro"></app-form-field>
            @if(isCadastro && !buscouAd) {
              <app-button-padrao icon="search" color="#fff" (buttonClick)="buscarAd()" [ngStyle]="verificarErrorEmailForm() ? {'top': '-4.2vh'} : {}" class="button-email"></app-button-padrao>
            }@else if(isCadastro && buscouAd){
              <app-button-padrao icon="close" color="#fff" (buttonClick)="resetarAd()" class="button-email"></app-button-padrao>
            }
          </div>
          @if (usuarios.length > 0) {
            <div class="autocomplete">
              @for (usu of usuarios; track $index) {
                <mat-option (click)="usuario = usu; configurarUsuarioFormBuilder(); usuarios = []">{{ usu.nome }}</mat-option>
              }
            </div>
          }

          @if(buscouAd){
            <app-form-field formControlName="nome" [disabled]="!!usuario.ldapHabilitado" label="Nome" heightFormField="35px" (changeValue)="alteracaoService.camposAlterado()"></app-form-field>

            <div class="flex-direction-row gap-5" style="justify-content: space-between;">
              <div class="flex-direction-column gap-5 width-20">
                <span class="label">Foto</span>
                @if (imgUsuario) {
                  <img [src]="imgUsuario" class="cursor-pointer" (click)="fileInputUsu.click()"
                       (keydown.enter)="fileInputUsu.click()" tabindex="0" role="button" alt="Foto do usuário" />
                } @else {
                  @if (usuario.uuid && usuario.extensaoImg) {
                    <img [src]="gerarUrl(usuario.uuid, usuario.extensaoImg, 'usuario-img')" class="modal-lateral-imagem" (click)="fileInputUsu.click()"
                         (keydown.enter)="fileInputUsu.click()" tabindex="0" role="button" alt="Foto do usuário" />
                  } @else {
                    <app-button-padrao icon="add_photo_alternate" fontSize="24px" widthIcon="35px" heightIcon="35px"
                                       classIcon="material-icons-outlined" (buttonClick)="fileInputUsu.click()"></app-button-padrao>
                  }
                }
              </div>
              <app-select-one
                style="width: calc(80% - 35px)"
                formControlName="perfil"
                label="Perfil"
                [listaInput]="perfis"
                campo="nome"
                widthFormField="100%"
                heightFormField="35px"
                (selecionarItem)="alteracaoService.camposAlterado()">
              </app-select-one>
            </div>
            <input type="file" accept="image/*" #fileInputUsu (change)="selecionarFotoUsuario($event); alteracaoService.camposAlterado()" hidden="" />

            <div class="container-edicao-modal-lateral" style="flex-direction: row; justify-content: space-between;">
              <app-select-one
                style="width: calc(100%)"
                formControlName="setor"
                label="Setor"
                [listaInput]="setores"
                campo="nome"
                widthFormField="100%"
                heightFormField="35px"
                (selecionarItem)="alteracaoService.camposAlterado()">
              </app-select-one>
            </div>
            <div class="container-edicao-modal-lateral" style="flex-direction: row; justify-content: space-between;">
              <app-form-field formControlName="telefone" style="width: 48%;" label="Telefone" heightFormField="35px" mask="(00) 90000-0000" (changeValue)="alteracaoService.camposAlterado()" [isEdicao]="!isCadastro"></app-form-field>
              <app-form-field formControlName="cpf" style="width: 48%;" label="Cpf" [disabled]="!!usuario.cpf" heightFormField="35px" mask="000.000.000-00" (changeValue)="alteracaoService.camposAlterado()" [isEdicao]="!isCadastro"></app-form-field>
            </div>
          }
        </div>
      </form>
    } @else {
      <div class="main-modal-lateral-info">
        <div class="container-info-modal-lateral">
          <span class="label">Email</span>
          <span class="font-12 ellipse">{{usuario.email}}</span>
        </div>
        <div class="container-info-modal-lateral">
          <span class="label">Nome</span>
          <span class="font-12 ellipse">{{usuario.nome}}</span>
        </div>
        <div class="container-info-modal-lateral">
          <span class="label">Foto</span>
          @if (usuario.uuid && usuario.extensaoImg) {
            <img [src]="gerarUrl(usuario.uuid, usuario.extensaoImg, 'usuario-img')" class="modal-lateral-imagem" alt="Foto do usuário"/>
          } @else {
            <img src="./assets/icones/no-img-default.png" style="width: 25px; height: 25px" alt="Foto do usuário" />
          }
        </div>
        <div class="container-info-modal-lateral">
          <span class="label">Perfil</span>
          <span class="font-12 ellipse">{{usuario.perfil?.nome}}</span>
        </div>
        <div class="container-info-modal-lateral">
          <span class="label">Setor</span>
          <!-- burro wilson -->
          <span class="font-12 ellipse">{{usuario.setorDTO?.nome ?? 'Sem setor'}}</span>
        </div>
        <div class="container-info-modal-lateral">
          <span class="label">Status</span>
          <span class="font-12 ellipse">{{usuario.ativo ? 'Ativo' : 'Inativo'}}</span>
        </div>
      </div>
    }
  </div>

  @if (!visualizar) {
    <div class="botoes-modal-lateral">
      <app-button-padrao
        width="100%"
        [label]="salvando ? 'Salvando...' : 'Salvar'"
        [backgroundColor]="formUsuario.invalid ? 'grey' : 'var(--verde-padrao)'"
        [color]="formUsuario.invalid ? 'dark-grey' : 'white'"
        [type]="'submit'"
        [disabled]="formUsuario.invalid || salvando"
        (buttonClick)="salvar()">
      </app-button-padrao>
      <app-button-padrao
        width="100%"
        label="Cancelar"
        backgroundColor="white"
        color="var(--vermelho-padrao)"
        [disabled]="salvando"
        (buttonClick)="cancelar()"
        borderColor="var(--vermelho-padrao)"
        borderStyle="solid"
        borderWidth="1px">
      </app-button-padrao>
    </div>
  }
</div>
